<template>
  <div class="procurement-layout">
    <div v-if="!sidebarCollapsed" class="proc-sidebar-backdrop" @click="toggleSidebar"></div>
    <button v-if="sidebarCollapsed" class="proc-floating-toggle" @click="toggleSidebar" title="Open menu" aria-label="Open menu">
      <i class="fas fa-chevron-right"></i>
    </button>
    <aside class="proc-sidebar" :class="{ 'proc-sidebar-collapsed': sidebarCollapsed }">
      <div class="proc-sidebar-header">
        <h6 class="mb-0">Procurement</h6>
        <small class="text-muted">Purchasing & Suppliers</small>
        <button type="button" class="proc-sidebar-close" @click="toggleSidebar" aria-label="Close menu">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <nav class="proc-nav">
        <RouterLink to="/procurement/dashboard" class="proc-nav-link" active-class="proc-nav-link-active">
          <i class="fas fa-tachometer-alt me-2"></i>
          Dashboard
        </RouterLink>

        <div class="proc-nav-section-label">Purchase Requests</div>
        <RouterLink to="/procurement/purchase-requests/add" class="proc-nav-link" active-class="proc-nav-link-active">
          <i class="fas fa-plus me-2"></i>
          Add Requisition
        </RouterLink>
        <RouterLink to="/procurement/purchase-requests" class="proc-nav-link" active-class="proc-nav-link-active">
          <i class="fas fa-list me-2"></i>
          Requisitions
        </RouterLink>

        <div class="proc-nav-section-label">Tenders</div>
        <RouterLink to="/procurement/tenders/add" class="proc-nav-link" active-class="proc-nav-link-active">
          <i class="fas fa-plus me-2"></i>
          Add Tender
        </RouterLink>
        <RouterLink to="/procurement/tenders" class="proc-nav-link" active-class="proc-nav-link-active">
          <i class="fas fa-gavel me-2"></i>
          Manage Tenders
        </RouterLink>
        <RouterLink to="/procurement/tenders/submissions" class="proc-nav-link" active-class="proc-nav-link-active">
          <i class="fas fa-file-lines me-2"></i>
          Tender Submissions
        </RouterLink>

        <div class="proc-nav-section-label">Suppliers & Purchases</div>
        <RouterLink to="/procurement/suppliers/add" class="proc-nav-link" active-class="proc-nav-link-active">
          <i class="fas fa-user-plus me-2"></i>
          Add Supplier
        </RouterLink>
        <RouterLink to="/procurement/suppliers" class="proc-nav-link" active-class="proc-nav-link-active">
          <i class="fas fa-truck me-2"></i>
          Manage Suppliers
        </RouterLink>
        <div class="proc-nav-section-label">Products</div>
        <RouterLink to="/inventory/products/add" class="proc-nav-link" active-class="proc-nav-link-active">
          <i class="fas fa-box-open me-2"></i>
          Add Product
        </RouterLink>
        <RouterLink to="/inventory/products" class="proc-nav-link" active-class="proc-nav-link-active">
          <i class="fas fa-boxes me-2"></i>
          View Products
        </RouterLink>
        <RouterLink to="/procurement/purchases/add" class="proc-nav-link" active-class="proc-nav-link-active">
          <i class="fas fa-file-invoice me-2"></i>
          Add Purchase
        </RouterLink>
        <RouterLink to="/procurement/purchases" class="proc-nav-link" active-class="proc-nav-link-active">
          <i class="fas fa-boxes me-2"></i>
          View Purchases
        </RouterLink>
      </nav>
    </aside>
    <main class="proc-main">
      <div class="proc-topbar">
        <button type="button" class="proc-toggle-btn" @click="toggleSidebar" :aria-expanded="!sidebarCollapsed" title="Toggle menu">
          <i :class="['fas', sidebarCollapsed ? 'fa-chevron-right' : 'fa-bars']"></i>
        </button>
        <slot name="topbar" />
      </div>
      <router-view v-slot="{ Component }">
        <Transition name="page" mode="out-in">
          <component :is="Component" :key="$route.path" />
        </Transition>
      </router-view>
    </main>
  </div>
</template>

<script>
export default {
  name: 'ProcurementLayout',
  data() {
    return {
      sidebarCollapsed: false,
    }
  },
  mounted() {
    this.checkMobileSidebar()
    window.addEventListener('resize', this.checkMobileSidebar)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobileSidebar)
  },
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    },
    checkMobileSidebar() {
      if (window.innerWidth >= 992) {
        this.sidebarCollapsed = false
      } else if (window.innerWidth < 992 && !this.sidebarCollapsed) {
        this.sidebarCollapsed = true
      }
    },
  },
}
</script>

<style scoped>
.procurement-layout { display: flex; min-height: calc(100vh - 60px); align-items: flex-start; }
.proc-sidebar {
  /* responsive sidebar: fixed flex-basis but able to shrink on narrow viewports */
  flex: 0 0 240px;
  max-width: 18rem;
  min-width: 12rem;
  width: 240px;
  background: #fff;
  padding: 1rem;
  border-right: 1px solid #e5e7eb;
  box-sizing: border-box;
  position: sticky;
  top: var(--app-header-height, 60px); /* stays below fixed header; uses runtime CSS var */
  height: calc(100vh - var(--app-header-height, 60px));
  overflow: auto;
}
.proc-sidebar-header { border-bottom: 1px solid #e5e7eb; padding-bottom: 0.6rem; margin-bottom: 0.6rem; }
.proc-nav { display:flex; flex-direction:column; gap:0.25rem }
.proc-nav-link { display:flex; align-items:center; padding:0.45rem 0.6rem; color:#374151; text-decoration:none; border-radius:4px }
.proc-nav-link:hover { background:#f1f5f9; color:#1d4ed8 }
.proc-nav-link-active { background:#2563eb; color:#fff }
.proc-nav-section-label { margin-top:1rem; font-size:0.75rem; text-transform:uppercase; color:#9ca3af }
.proc-main { flex:1; padding:0.75rem 1rem; background:#f8fafc; min-width: 0; }
.proc-topbar { display:flex; align-items:center; justify-content:flex-end; gap:8px; margin-bottom:0.5rem }
.proc-sidebar-close { display:none; margin-left:auto; padding:4px 8px; border:none; background:transparent; cursor:pointer; font-size:1.1rem; color:#6b7280 }
.proc-toggle-btn { display:none; padding:6px 10px; border:1px solid #e5e7eb; background:#fff; border-radius:6px; cursor:pointer; font-size:0.9rem }
.proc-floating-toggle { display:none; position:fixed; left:8px; top:calc(var(--app-header-height, 60px) + 8px); z-index:1100; width:36px; height:36px; border-radius:6px; border:1px solid rgba(0,0,0,0.08); background:#fff; cursor:pointer; box-shadow:0 4px 11px rgba(0,0,0,0.08) }
.proc-sidebar-backdrop { display:none; position:fixed; inset:0; background:rgba(0,0,0,0.3); z-index:1040; }

@media (max-width: 991px) {
  .procurement-layout { flex-direction: column; }
  .proc-sidebar {
    position: fixed;
    top: var(--app-header-height, 60px);
    left: 0;
    bottom: 0;
    width: 260px;
    max-width: 85vw;
    z-index: 1050;
    box-shadow: 4px 0 11px rgba(0,0,0,0.1);
    transition: transform 0.25s ease;
  }
  .proc-sidebar-collapsed {
    transform: translateX(-100%);
    pointer-events: none;
  }
  .proc-sidebar-header { display: flex; align-items: center; flex-wrap: wrap; gap: 4px; }
  .proc-sidebar-close { display: block; }
  .proc-toggle-btn { display: inline-flex; align-items: center; justify-content: center; }
  .proc-floating-toggle { display: inline-flex; align-items: center; justify-content: center; }
  .proc-sidebar-backdrop { display: block; }
  .proc-main { padding: 0.5rem 0.75rem; }
}

@media (min-width: 992px) {
  .proc-sidebar-collapsed { transform: none !important; }
  .proc-floating-toggle { display: none !important; }
}
</style>
